import { useSearchParams } from 'react-router-dom'
import { getWorkspaceProjectFromParams } from '@/lib/utils'
import { Button } from '@/components/catalyst-ui/button'

export default function NotFoundPage() {
  const [searchParams] = useSearchParams()
  const { workspace, project } = getWorkspaceProjectFromParams(searchParams)

  const homeUrl = workspace
    ? project
      ? `/projects?workspace=${workspace}&project=${project}`
      : `/projects?workspace=${workspace}`
    : '/'

  return (
    <div className="flex max-w-screen min-h-screen items-center justify-center backdrop-brightness-98 -m-10">
      <div className="max-w-md w-full bg-white text-center border border-[#E4E4E7] shadow-[0px_1px_3px_0px_#0000001A,0px_1px_2px_-1px_#0000001A] rounded-lg p-6">
        {/* <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
          <svg
            className="h-6 w-6 text-red-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
            />
          </svg>
        </div> */}

        <h1 className="text-base font-semibold text-gray-900">404 Page Not Found</h1>
        <p className="mt-2 text-sm text-[#A1A1AA] font-medium">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>

        <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            dark
            to={homeUrl}
            className="inline-flex items-center"
          >
            Go to Dashboard
          </Button>

          <Button
            outline
            onClick={() => window.history.back()}
            className="inline-flex items-center px-4 py-2 "
          >
            <svg
              className="-ml-1 mr-2 h-4 w-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
            Go Back
          </Button>
        </div>
      </div>
    </div>
  )
}
